import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { GetGlobalDataApi } from '../../../../http/Services/UserApi'
import { getGlobalDataAction } from '../../../../redux/action/globalDataAction'
import { onChangeInputData, order, orderNum } from '../../../globalParams/GlobalDataFilter'
import GeneralContainer from '../../../globalParams/GeneralContainer'
import Searcher from '../../../globalParams/filter/Searcher'
import Paginator from '../../../globalParams/filter/Paginator'
import Info from '../../../globalParams/filter/Info'
import { Table } from '../../../../components/table/Table'
import { Tr } from '../../../../components/table/Tr'
import { ThParam } from '../../../globalParams/ThParam'
import Loading from '../../../globalParams/Loading'
import { Td } from '../../../../components/table/Td'
import { DateConvert } from '../../../../utils/dateConvert'
import Detail from '../../../globalParams/Detail'
import { GetWareHousesWithUserNotNullApi } from '../../../../http/Services/WareHouseApi'

export default function WareHouseList() {

    const dispatch = useDispatch()

    const [stateData, setStateData] = useState("loading...")
    const [load, setLoad] = useState(false)
    const [data, setData] = useState([])
    const [back, setBack] = useState([])
    const [items, setItems] = useState([])
    const [item, setItem] = useState({})
    const [perPage, setPerPage] = useState(10)
    const [currentPage, setCurrentPage] = useState(1)
    const [totalPages, setTotalPages] = useState(1)
    const [total, setTotal] = useState(0)
    const [desc, setDesc] = useState(true)
    const [byQuery, setByQuery] = useState("")
    const [full, setFull] = useState(true)

    useEffect(() => {
        setStateData("loading...")
        setItem({})
        const getOrders = async () => {
            try {
                let res = await GetWareHousesWithUserNotNullApi();
                if (res.status === 200) {
                    if (res.data.length > 0) {
                        setStateData("")
                        setByQuery("")
                    }
                    else {
                        setStateData("sin registros...")
                    }
                    setDesc(false)
                    setCurrentPage(1)
                    setData(res.data)

                    getGlobalData()
                }
            } catch (error) {
                setStateData("Error al cargar lista")
            }

        }
        getOrders()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [load])


    useEffect(() => {
        setTotal(back.length)
        let div = back.length / perPage
        if (div - parseInt(div) === 0) {
            setTotalPages(div)
        }
        else {
            setTotalPages(parseInt(div) + 1)
        }
    }, [back, perPage])

    useEffect(() => {
        setCurrentPage(1)
    }, [perPage])


    useEffect(() => {
        // no replicar a = b por que se toma como si fuera el mismo
        const dataBackup = Array.from(data)
        setItems([
            ...dataBackup
                // .filter(a => a.full_data?.trim().toLowerCase().includes(byQuery) || a.telefono.toLowerCase().includes(byQuery))
                .filter(a => a.full_data?.trim().toLowerCase().includes(byQuery))
                .splice((currentPage * perPage - perPage), perPage)
        ])
        setBack([
            ...data
                // .filter(a => a.full_data?.trim().toLowerCase().includes(byQuery) || a.telefono.toLowerCase().includes(byQuery))
                .filter(a => a.full_data?.trim().toLowerCase().includes(byQuery))
        ])

        let div = back.length / perPage
        if (div - parseInt(div) === 0) {
            setTotalPages(div)
        }
        else {
            setTotalPages(parseInt(div) + 1)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data, currentPage, perPage])

    const getGlobalData = async () => {
        try {
            let res = await GetGlobalDataApi();
            if (res.status === 200) {
                dispatch(getGlobalDataAction(res.data))
            }
        } catch (error) {
            console.log('error in reducers')
        }
    }

    const onChangeInput = (e) => {
        onChangeInputData(
            setByQuery,
            e,
            data,
            currentPage,
            setCurrentPage,
            setItems,
            perPage,
            setBack,
            setStateData
        )
    }

    return (
        <GeneralContainer>
            <div className="row gx-3">
                <div className={`col-12 col-md-${full ? '12' : '6'}`}>
                    {
                        <>
                            <div className="card card-danger card-outline">
                                <div className="p-1">
                                    <Searcher
                                        onChangeInput={onChangeInput}
                                        byQuery={byQuery}
                                    />
                                </div>
                                <div className="p-1">
                                    <Paginator
                                        currentPage={currentPage}
                                        setCurrentPage={setCurrentPage}
                                        totalPages={totalPages}
                                        setPerPage={setPerPage}
                                        perPage={perPage}
                                        setLoad={setLoad}
                                        load={load}
                                        stateData={stateData}
                                        setFull={setFull}
                                        full={full}
                                    />
                                </div>
                                <div className=" p-1 table-warning rounded-top">
                                    <Info
                                        total={total}
                                        currentPage={currentPage}
                                        perPage={perPage}
                                        totalPages={totalPages}
                                    />
                                </div>
                                <div className="card-body p-1">
                                    <div className="content-basic">
                                        <Table>
                                            <thead>
                                                <Tr>
                                                    <ThParam
                                                        label='Departamento'
                                                        onClick={() => order('dpto', data, desc, setData, setDesc)}
                                                        width='140px'
                                                    />
                                                    <ThParam
                                                        label='Encargado'
                                                        onClick={() => order('u_nombre', data, desc, setData, setDesc)}
                                                        width='140px'
                                                    />
                                                    <ThParam
                                                        label='Producto'
                                                        onClick={() => order('p_producto', data, desc, setData, setDesc)}
                                                        width='140px'
                                                    />
                                                    <ThParam
                                                        label='Estado'
                                                        onClick={() => order('estado', data, desc, setData, setDesc)}
                                                        width='95px'
                                                    />
                                                    <ThParam
                                                        label='Actual'
                                                        onClick={() => orderNum('cantidad_actual', data, desc, setData, setDesc)}
                                                        width='85px'
                                                    />
                                                    <ThParam
                                                        label='Fecha de registro'
                                                        onClick={() => order('created_at', data, desc, setData, setDesc)}
                                                        width='220px'
                                                    />
                                                </Tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    stateData !== "" ?
                                                        <tr>
                                                            <td colSpan={5}>
                                                                {stateData === "loading..."
                                                                    ?
                                                                    <Loading />
                                                                    :
                                                                    <div
                                                                        style={{
                                                                            fontSize: '14px',
                                                                            fontWeight: 'bold',
                                                                            color: 'rgba(0,0,0,.4)',
                                                                            padding: '5px'
                                                                        }}
                                                                    >
                                                                        {stateData}
                                                                    </div>
                                                                }
                                                            </td>
                                                        </tr>
                                                        :
                                                        items?.map((data) => (
                                                            <Tr
                                                                key={data.id}
                                                                onClick={() => setItem(data)}
                                                                mark={item && item.id === data.id && true}
                                                            >
                                                                <Td
                                                                    width='140px'
                                                                >
                                                                    <div className="row">
                                                                        <div className="col d-flex"
                                                                            style={{
                                                                                alignItems: 'center'
                                                                            }}
                                                                        >
                                                                            <i className="bi bi-clipboard-fill d-flex p-1 text-secondary"
                                                                                style={{
                                                                                    fontSize: '18px'
                                                                                }}
                                                                            />
                                                                            <div className='badge-in-secondary'>
                                                                                {data.dpto}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </Td>
                                                                <Td
                                                                    width='140px'
                                                                >
                                                                    {data.u_nombre}{' '}
                                                                    {data.u_apellido_paterno}{' '}
                                                                    {data.u_apellido_materno}
                                                                </Td>
                                                                <Td
                                                                    width='140px'
                                                                >
                                                                    {data.p_nombre}
                                                                </Td>
                                                                <Td
                                                                    width='95px'
                                                                    center={true}
                                                                >
                                                                    <div className='badge-in-primary'>
                                                                        {data.estado}
                                                                    </div>
                                                                </Td>
                                                                <Td
                                                                    width='85px'
                                                                    center
                                                                >
                                                                    {data.cantidad_actual}
                                                                </Td>
                                                                <Td
                                                                    width='220px'
                                                                >
                                                                    {data.created_at ? DateConvert(data.created_at) : ''}
                                                                </Td>
                                                            </Tr>
                                                        ))
                                                }
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                                {
                                    total > perPage && stateData !== "loading..." &&
                                    <>
                                        <div className=" p-1 table-warning rounded-top">
                                            <Info
                                                total={total}
                                                currentPage={currentPage}
                                                perPage={perPage}
                                                totalPages={totalPages}
                                            />
                                        </div>
                                        <div className="p-1">
                                            <Paginator
                                                currentPage={currentPage}
                                                setCurrentPage={setCurrentPage}
                                                totalPages={totalPages}
                                                setPerPage={setPerPage}
                                                perPage={perPage}
                                                setLoad={setLoad}
                                                load={load}
                                                stateData={stateData}
                                                setFull={setFull}
                                                full={full}
                                                hiddenpaginator={true}
                                            />
                                        </div>
                                    </>
                                }
                            </div>
                        </>
                    }
                </div>
                {
                    item.id &&
                    <div className={`col-12 col-md-${full ? '12' : '6'}`}>
                        <div className="card">
                            <div className='card-header p-1'>
                                <div className='row'>
                                    <div className='col-8'>
                                        Detalles del stock
                                    </div>
                                    <div className="col-4 d-flex justify-content-end">
                                        <div className='p-0'>
                                            <i className='bi bi-x-lg btn py-0 px-1' onClick={() => setItem({})} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body p-0">
                                <Detail
                                    detail={[
                                        { label: 'Departamento', value: item.dpto },
                                        { label: 'Encargado', value: (item.u_nombre + ' ' + (item.u_apellido_paterno ? item.u_apellido_paterno + ' ' : '') + (item.u_apellido_materno ? item.u_apellido_materno : '')) },
                                        { label: 'Producto', value: item.p_nombre },
                                        { label: 'Estado', value: item.estado },
                                        { label: 'Descripción del producto', value: item.p_descripcion },
                                        { label: 'Precio por unidad', value: (item.p_precio ? item.p_precio : 0) + ' Bs.' },
                                        { label: 'Cantidad anterior', value: item.cantidad_anterior },
                                        { label: 'Cantidad actual', value: item.cantidad_actual },
                                        { label: 'Fecha de registro', value: DateConvert(item.created_at) }
                                    ]}
                                />
                            </div>
                        </div>
                    </div>
                }
            </div>
            {/* <ModalCreateWareHouse
        show={toggleModalCreate}
        handleClose={handleClose}
        load={load}
        setLoad={setLoad}
      />
      <ModalConfirmation
        show={modalConfirmation}
        handleClose={handleCloseConfirmation}
        text='¿Seguro que desea eliminar este stock?'
        buttonText='Eliminar'
        variant='danger'
        onClick={() => deleteData()}
        buttonDisabled={buttonDisabled}
      /> */}
        </GeneralContainer >
    )
}